// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Vue from "vue";
import Router from "vue-router";
import store from "../store";
Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/* Router Modules */
// import componentsRouter from './modules/components'
import storeRouter from "./modules/store";
import orderRouter from "./modules/order";
import userRouter from "./modules/user";
import distributionRouter from "./modules/distribution";
import marketingRouter from "./modules/marketing";
import financialRouter from "./modules/financial";
import contentRouter from "./modules/content";
import operationRouter from "./modules/operation";
import appSettingRouter from "./modules/appSetting";
import maintainRouter from "./modules/maintain";
import mobileRouter from "./modules/mobile";
import statistic from "./modules/statistic";
import tagRouter from "./modules/tag";
import copyright from "./modules/copyright";
import firm from "./modules/firm";
import imhomepage from "./modules/imhomepage";
import adConfig from "./modules/adConfig";
import dauStats from "./modules/dauStats";
import kongqiweishi from "./modules/kongqiweishi";
import organization from "./modules/organization";
import house from "./modules/house";
import designWeek from "./modules/designWeek";
import ad from "./modules/ad";
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 *
 */
// console.log('store.state.userLogin.account', store.state.userLogin.account)
// console.log('store', store)
export var constantRoutes = [
// 商品
storeRouter,
// 订单
orderRouter,
// 会员
userRouter,
// 分销
distributionRouter,
// 营销
marketingRouter,
// 财务
financialRouter,
// 内容
contentRouter,
// 设置
operationRouter,
// 应用
appSettingRouter,
// 维护
maintainRouter,
//移动端管理
mobileRouter,
// 统计管理
statistic,
//分销商
kongqiweishi,
//组织管理
organization,
//楼盘
house,
// 版权
copyright,
//标签
tagRouter, firm,
// 桌面端广告
imhomepage,
// 展商广告配置
adConfig,
// 设计周管理
designWeek,
// 日活统计
dauStats,
// 广告管理
ad, {
  path: "/404",
  component: function component() {
    return import("@/views/error-page/404");
  },
  hidden: true
}, {
  path: "/redirect",
  component: Layout,
  hidden: true,
  children: [{
    path: "/redirect/:path(.*)",
    component: function component() {
      return import("@/views/redirect/index");
    }
  }]
}, {
  path: "/auth-send",
  component: function component() {
    return import("@/views/mobile/auth-send");
  },
  hidden: true
}, {
  path: "/login",
  component: function component() {
    return import("@/views/login/index");
  },
  hidden: true
}, {
  path: "/auth-redirect",
  component: function component() {
    return import("@/views/login/auth-redirect");
  },
  hidden: true
}, {
  path: "/401",
  component: function component() {
    return import("@/views/error-page/401");
  },
  hidden: true
}, {
  path: "/",
  component: Layout,
  redirect: "/dashboard",
  // redirect: store.state.userLogin.account === 'admin' ? '/dashboard' : '/',
  children: [{
    path: "dashboard",
    component: function component() {
      return import("@/views/dashboard/index");
    },
    name: "Dashboard",
    meta: {
      title: "主页",
      icon: "dashboard",
      affix: true
    }
  }, {
    path: "product",
    name: "product",
    meta: {
      title: "商品统计"
    },
    component: function component() {
      return import("@/views/statistic/product/index");
    }
  }, {
    path: "statuser",
    name: "statuser",
    meta: {
      title: "用户统计"
    },
    component: function component() {
      return import("@/views/statistic/user/index");
    }
  }, {
    path: "transaction",
    name: "transaction",
    meta: {
      title: "交易统计"
    },
    component: function component() {
      return import("@/views/statistic/transaction/index");
    }
  }, {
    path: "exhibitor",
    name: "exhibitor",
    meta: {
      title: "展商统计"
    },
    component: function component() {
      return import("@/views/statistic/exhibitor/index");
    }
  }, {
    path: "imageStatistics",
    name: "imageStatistics",
    meta: {
      title: "试装统计"
    },
    component: function component() {
      return import("@/views/statistic/aiImage/index");
    }
  }]
}, {
  path: "/setting/uploadPicture",
  component: function component() {
    return import("@/components/uploadPicture/index.vue");
  },
  name: "uploadPicture"
},
//字典表
{
  path: "/dict",
  component: Layout,
  redirect: "/dict/list",
  children: [{
    path: "/dict/list",
    component: function component() {
      return import("@/views/dict/dictList.vue");
    },
    name: "DictList"
  }, {
    path: "/dict/data",
    meta: {
      title: "数据字典"
    },
    component: function component() {
      return import("@/views/dict/dictData.vue");
    },
    name: "dictData"
  }]
},
// 404 page must be placed at the end !!!
{
  path: "*",
  redirect: "/404",
  hidden: true
}];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export var asyncRoutes = [
  // 版权
  // copyright
];
var createRouter = function createRouter() {
  return new Router({
    // mode: 'history', // require service support
    mode: "history",
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;